/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Cmspage_Live_Page1Inputs */

const vi_cmspage_live_page1 = /** @type {(inputs: Cmspage_Live_Page1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang chạy trên web: /${i?.slug}`)
};

/**

* @param {Cmspage_Live_Page1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_live_page1 = /** @type {((inputs: Cmspage_Live_Page1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Live_Page1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_live_page1(inputs)
});
export { cmspage_live_page1 as "cmsPage_live_page" }